import type { FC } from 'react';
import { getDocumentationUrl } from '@gonfalon/docs/documentationUrl';
import { type SdkKey, getSdkInfoByKey, POPULAR_SDK_KEYS } from '@gonfalon/sdk-info/sdkInfo';
import { Heading, Link, Text } from '@launchpad-ui/components';

import { trackSdkSetupReadDocsClicked } from '../../analytics';

import styles from './SdkSetupContentHeader.module.css';
interface SdkSetupContentHeaderProps {
  sdk?: SdkKey;
}

export const SdkSetupContentHeader: FC<SdkSetupContentHeaderProps> = ({ sdk }) => {
  if (!sdk) {
    return null;
  }

  const sdkInfo = getSdkInfoByKey(sdk);
  if (!sdkInfo) {
    return null;
  }

  const handleReadDocsClick = () => {
    trackSdkSetupReadDocsClicked(sdk);
  };

  return (
    <div className={styles.container}>
      <Heading level={2} size="medium" className={styles.title}>
        Set up {sdkInfo.name} SDK
      </Heading>
      {(POPULAR_SDK_KEYS as readonly SdkKey[]).includes(sdk) && (
        <Text>
          Need help? Read the{' '}
          <Link
            href={getDocumentationUrl(sdkInfo.docsPath)}
            target="_blank"
            rel="noopener noreferrer"
            onPress={handleReadDocsClick}
          >
            {sdkInfo.name} onboarding docs.
          </Link>
        </Text>
      )}
    </div>
  );
};
